/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_edges_CreditApplicationPaginatedEdge_node_CreditApplicationPaginated_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly legalBusinessName: string | null };

export type GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_edges_CreditApplicationPaginatedEdge_node_CreditApplicationPaginated = { readonly __typename: 'CreditApplicationPaginated', readonly salesforceCreditId: string, readonly startedAt: any | null, readonly shouldBeExpiredAt: any | null, readonly status: _Types.CreditApplicationStatus | null, readonly fundableLimit: number | null, readonly businessInfo: GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_edges_CreditApplicationPaginatedEdge_node_CreditApplicationPaginated_businessInfo_CreditApplicationBusinessInfo | null };

export type GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_edges_CreditApplicationPaginatedEdge = { readonly __typename: 'CreditApplicationPaginatedEdge', readonly cursor: string | null, readonly node: GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_edges_CreditApplicationPaginatedEdge_node_CreditApplicationPaginated | null };

export type GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_pageInfo_PageInfo = { readonly __typename: 'PageInfo', readonly endCursor: string | null, readonly hasNextPage: boolean, readonly hasPreviousPage: boolean, readonly startCursor: string | null };

export type GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection = { readonly __typename: 'CreditApplicationPaginatedConnection', readonly totalCount: number | null, readonly edges: ReadonlyArray<GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_edges_CreditApplicationPaginatedEdge | null> | null, readonly pageInfo: GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection_pageInfo_PageInfo };

export type GetCreditApplications_Query = { readonly __typename: 'Query', readonly creditApplicationsPaginated: GetCreditApplications_creditApplicationsPaginated_CreditApplicationPaginatedConnection | null };


export type GetCreditApplicationsVariables = _Types.Exact<{
  after?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
  first?: _Types.InputMaybe<_Types.Scalars['Int']['input']>;
  name?: _Types.InputMaybe<_Types.Scalars['String']['input']>;
  category?: _Types.InputMaybe<_Types.CreditApplicationCategory>;
  orderBy?: _Types.InputMaybe<ReadonlyArray<_Types.InputMaybe<_Types.CreditApplicationSortField>> | _Types.InputMaybe<_Types.CreditApplicationSortField>>;
  orderDirections?: _Types.InputMaybe<ReadonlyArray<_Types.InputMaybe<_Types.SortDirection>> | _Types.InputMaybe<_Types.SortDirection>>;
}>;


export type GetCreditApplications = GetCreditApplications_Query;


export const GetCreditApplicationsDocument = gql`
    query GetCreditApplications($after: String, $first: Int, $name: String, $category: CreditApplicationCategory, $orderBy: [CreditApplicationSortField], $orderDirections: [SortDirection]) {
  creditApplicationsPaginated(
    after: $after
    first: $first
    name: $name
    category: $category
    orderBy: $orderBy
    orderDirections: $orderDirections
  ) {
    edges {
      cursor
      node {
        salesforceCreditId
        businessInfo {
          legalBusinessName
        }
        startedAt
        shouldBeExpiredAt
        status
        fundableLimit
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      hasPreviousPage
      startCursor
    }
    totalCount
  }
}
    `;

/**
 * __useGetCreditApplications__
 *
 * To run a query within a React component, call `useGetCreditApplications` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditApplications` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditApplications({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      name: // value for 'name'
 *      category: // value for 'category'
 *      orderBy: // value for 'orderBy'
 *      orderDirections: // value for 'orderDirections'
 *   },
 * });
 */
export function useGetCreditApplications(baseOptions?: Apollo.QueryHookOptions<GetCreditApplications, GetCreditApplicationsVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCreditApplications, GetCreditApplicationsVariables>(GetCreditApplicationsDocument, options);
      }
export function useGetCreditApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCreditApplications, GetCreditApplicationsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCreditApplications, GetCreditApplicationsVariables>(GetCreditApplicationsDocument, options);
        }
export function useGetCreditApplicationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCreditApplications, GetCreditApplicationsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCreditApplications, GetCreditApplicationsVariables>(GetCreditApplicationsDocument, options);
        }
export type GetCreditApplicationsHookResult = ReturnType<typeof useGetCreditApplications>;
export type GetCreditApplicationsLazyQueryHookResult = ReturnType<typeof useGetCreditApplicationsLazyQuery>;
export type GetCreditApplicationsSuspenseQueryHookResult = ReturnType<typeof useGetCreditApplicationsSuspenseQuery>;
export type GetCreditApplicationsQueryResult = Apollo.QueryResult<GetCreditApplications, GetCreditApplicationsVariables>;